import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { StyledCircularChip } from '@openx/components-core/lib/Chip/StyledChip.ts';
import { LabeledValue } from '@openx/components-core/lib/Value/LabeledValue/LabeledValue.tsx';
import type { OptionsMap } from '@openx/types/options.ts';
import { toPercentString } from '@openx/utils/lib/toPercentString.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type DiscountProps = {
  bannerAndVideoDiscount: string | null;
  ctvDiscount: string | null;
  demandPartnerById: OptionsMap;
  demandPartnerId: string | null | undefined;
  name: string;
  seatIds: Record<string, true> | null;
};

export const DealDiscount = ({
  bannerAndVideoDiscount,
  ctvDiscount,
  demandPartnerById,
  demandPartnerId,
  name,
  seatIds,
}: DiscountProps) => {
  const { t } = useTranslation();

  const demandPartnerName = demandPartnerId && (demandPartnerById[demandPartnerId]?.name ?? demandPartnerId);
  const seatsCount = useMemo(() => (seatIds ? Object.values(seatIds).length : null), [seatIds]);

  return (
    <Stack>
      <Typography variant="body1Bold">{name}</Typography>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          alignItems: 'center',
        }}
      >
        <LabeledValue label={t('Banner and Video')} value={toPercentString(bannerAndVideoDiscount)} />
        <LabeledValue label={t('CTV')} value={toPercentString(ctvDiscount)} />

        {demandPartnerName && <LabeledValue label={t('DSP')} value={demandPartnerName} />}

        {seatsCount && (
          <Stack
            direction="row"
            spacing={1}
            sx={{
              alignItems: 'center',
            }}
          >
            <Typography color="textSecondary" variant="body2">
              {t('Assigned Seats')}:
            </Typography>

            <StyledCircularChip label={seatsCount} size="small" />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
